import { useEffect } from "react";

const SITE = "https://www.giacomobertagnolli.it";

function upsertMeta(attr, value) {
  let el = document.head.querySelector(`meta[${attr.split("=")[0]}=${attr.split("=")[1]}]`);
  if (!el) {
    el = document.createElement("meta");
    const [k, v] = attr.split("=");
    el.setAttribute(k, v.replace(/"/g, ""));
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

/* Titolo, description, canonical e OG unici per ogni pagina.
   Il sito è una SPA: il <head> statico copre la home, questo componente
   aggiorna i metadati quando si naviga (Googlebot esegue JS; con il prerender
   attivo in produzione li vedono anche gli altri crawler). */
export default function Seo({ title, description, path = "/", robots }) {
  useEffect(() => {
    document.title = title;
    upsertMeta('name="description"', description);
    upsertMeta('name="robots"', robots || "index, follow, max-image-preview:large, max-snippet:-1");
    upsertMeta('property="og:title"', title);
    upsertMeta('property="og:description"', description);
    upsertMeta('property="og:url"', SITE + path);
    upsertMeta('name="twitter:title"', title);
    upsertMeta('name="twitter:description"', description);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", SITE + path);
  }, [title, description, path, robots]);
  return null;
}
